import { render, staticRenderFns } from "./CollegeList.vue?vue&type=template&id=10b63353&scoped=true"
import script from "./CollegeList.vue?vue&type=script&lang=js"
export * from "./CollegeList.vue?vue&type=script&lang=js"
import style0 from "./CollegeList.vue?vue&type=style&index=0&id=10b63353&prod&scoped=true&lang=less"
import style1 from "./CollegeList.vue?vue&type=style&index=1&id=10b63353&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b63353",
  null
  
)

export default component.exports